import React from 'react';

const icPen = (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M9.49146 0L0 10.05V12H2.35176L12 2.316L9.49146 0ZM2.35176 10.944L1.50151 10.05L7.68844 3.57L8.5387 4.464L2.35176 10.944ZM8.53266 2.676L9.38895 1.788L10.2392 2.682L9.38895 3.576L8.53266 2.676Z'
            fill='#212121'
        />
    </svg>
);

export default icPen;
